import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2800To2899Service {

  constructor() { }
}
